import clientsController from './clients'
import userController from './user'
import userRolesController from './user/role'
import staffController from './staff'
import itemController from './items'
import ItemCategoryController from './items/ItemCategory'
import itemGroupController from './itemGroup'
import itemTypeController from './items/ItemType'
import servicePointController from './servicePoint'
import servicePointUnitController from './servicePointUnit'
import ticketController from './tickets'
import businessController from './business'
import branchesController from './branches'
import businessRegistrationController from '../modules/business/services/businessRegistration'
import configurationController from './configurations'
import salesController from './sales'
import invoicesController from './invoices'
import paymentsController from './payments'
import servicesController from '../modules/services/services/services'
import serviceCategoryController from '../modules/services/services/serviceCategory'
import serviceTypeController from '../modules/services/services/serviceType'
import stockInController from '../modules/inventory/services/stockIn'
import stockOutController from '../modules/inventory/services/stockOut'
import transfersController from '../modules/inventory/services/transfers'
import inventoryLocationsController from '../modules/inventory/services/locations'
import itemMergesController from '../modules/inventory/services/itemMerges'
import unitsController from '../modules/inventory/services/units'
import itemUnitsController from '../modules/inventory/services/itemUnits'
import itemUnitPricesController from '../modules/inventory/services/itemUnitPrices'
import itemUnitConversionsController from '../modules/inventory/services/itemUnitConversions'
import baseUnitChangeController from '../modules/inventory/services/baseUnitChange'
import suppliersController from '../modules/procurement/services/suppliers'
import expensesController from '../modules/expense/services/expenses'
import expenseCategoriesController from '../modules/expense/services/expenseCategories'
import expenseItemsController from '../modules/expense/services/expenseItems'
import reportsController from '../modules/reports/services'
import commissionRulesController from '../modules/commission/services/commissionRules'
import enumsController from './enums'
import importsController from '../modules/import/services/imports'
import stockTakesController from './stockTakes'

export const API = {
  clients: clientsController,
  user: userController,
  userRole: userRolesController,
  staff: staffController,
  items: itemController,
  itemGroup: itemGroupController,
  itemCategory: ItemCategoryController,
  itemType: itemTypeController,
  servicePoint: servicePointController,
  servicePointUnit: servicePointUnitController,
  services: servicesController,
  serviceCategory: serviceCategoryController,
  serviceType: serviceTypeController,
  ticket: ticketController,
  business: businessController,
  branches: branchesController,
  businessRegistration: businessRegistrationController,
  configuration: configurationController,
  sales: salesController,
  invoices: invoicesController,
  payments: paymentsController,
  stockIn: stockInController,
  stockOut: stockOutController,
  transfers: transfersController,
  inventoryLocations: inventoryLocationsController,
  itemMerges: itemMergesController,
  units: unitsController,
  itemUnits: itemUnitsController,
  itemUnitPrices: itemUnitPricesController,
  itemUnitConversions: itemUnitConversionsController,
  baseUnitChange: baseUnitChangeController,
  suppliers: suppliersController,
  expenses: expensesController,
  expenseCategories: expenseCategoriesController,
  expenseItems: expenseItemsController,
  reports: reportsController,
  commissionRules: commissionRulesController,
  enums: enumsController,
  imports: importsController,
  stockTakes: stockTakesController,
}
